<div class="cookie" *ngIf="groupedSettings">
  <div class="cookie__close-background" (click)="onClosed.emit(true)"></div>
  <div class="cookie__content">

    <div class="cookie__content-header">
      <span>Diese Seite verwendet Cookies</span>
      <span class="cookie__content-header-close" (click)="onClosed.emit(true)"><brt-icon [icon]="'x-thin'"></brt-icon></span>
    </div>
    <div class="cookie__content-main">
      <div class="cookie__text-content">
        <p>
          Mit Ihrer Zustimmung helfen Sie uns dabei, die Services und Funktionen der Webseite zu verbessern, um Ihnen ein optimales Nutzungserlebnis zu ermöglichen. Dazu speichern wir und unsere Partner personenbezogene technische Daten zu Geräten und Nutzerverhalten für Marketing-, Analyse- und Optimierungszwecke. Nähere Informationen zu den Cookies finden Sie in unserer Datenschutzerklärung. Sie können der Setzung aller Cookies zustimmen oder eine selektive Auswahl treffen.
        </p>
        <p>
          Bitte beachten Sie, dass wir auch Cookies von US-amerikanischen Firmen zur Verfügung stellen. Wenn Sie der Cookie-Setzung zustimmen, gelangen Ihre durch die Cookies erhobenen personenbezogene Daten in die USA, wo Sie keinem dem EU-Datenschutzrecht angemessenen Schutzniveau unterliegen, Sie nur eingeschränkte, bis keine datenschutzrechtliche Rechte genießen und insbesondere auch die US-amerikanische Regierung Zugang zu diesen Daten erlangen kann. Die Ausspielung der zustimmungspflichtigen Cookies erfolgt durch den Google Tagmanger, der US-amerikanischen Firma Google. Wenn Sie daher der Cookie-Setzung zustimmen, so stimmen Sie auch zu, dass die Ausspielung über den Google Tag Manager erfolgt.
        </p>
      </div>

      <div class="cookie__settings" *ngIf="settingsOpened">
        <div class="cookie__settings-all">
          <div class="cookie__settings-row">
            <label class="checkbox">
              <input type="checkbox" [checked]="groupedSettings[0].selected || groupedSettings[0].partiallySelected" (change)="onInputChanged(groupedSettings[0])">
              <span class="custom-checkbox"><brt-icon [icon]="groupedSettings[0].partiallySelected ? 'reg-minus' : 'check'"></brt-icon></span>
              <span class="label">Alle auswählen</span>
            </label>
          </div>
        </div>

        <div class="cookie__settings-row cookie__settings-row--has-children">
          <div class="cookie__settings-row-checkbox">
            <label class="checkbox">
              <input type="checkbox" [checked]="groupedSettings[0].children[0].selected || groupedSettings[0].children[0].partiallySelected" (change)="onInputChanged(groupedSettings[0].children[0])">
              <span class="custom-checkbox"><brt-icon [icon]="groupedSettings[0].children[0].partiallySelected ? 'reg-minus' : 'check'"></brt-icon></span>
            </label>
          </div>

          <div class="cookie__settings-row-content" (click)="toggleAccordion($event)">
            <div class="cookie__settings-row-accordion-header">
              Funktionale Cookies
              <span><brt-icon [icon]="'reg-chevron-down'"></brt-icon></span>
            </div>

            <div class="cookie__settings-row-accordion-content-wrapper">
              <div class="cookie__settings-row-accordion-content">
                <span class="cookie__settings-row-accordion-content-hint">Für Funktionale Cookies können Sie hier Ihre Einstellungen festlegen.</span>
                <div class="cookie__settings-row-accordion-content-input-wrapper">
                  <label class="checkbox">
                    <input type="checkbox" [checked]="groupedSettings[0].children[0].children[0].selected" (change)="onInputChanged(groupedSettings[0].children[0].children[0])">
                    <span class="custom-checkbox"><brt-icon [icon]="'check'"></brt-icon></span>
                    <p>
                      <strong>Google Maps (US-amerikanischer Anbieter)</strong><br/>
                      Ermöglicht die Einbettung von Karten auf berufsreise.at
                    </p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cookie__settings-row cookie__settings-row--has-children">
          <div class="cookie__settings-row-checkbox">
            <label class="checkbox">
              <input type="checkbox" [checked]="groupedSettings[0].children[1].selected || groupedSettings[0].children[1].partiallySelected" (change)="onInputChanged(groupedSettings[0].children[1])">
              <span class="custom-checkbox"><brt-icon [icon]="groupedSettings[0].children[1].partiallySelected ? 'reg-minus' : 'check'"></brt-icon></span>
            </label>
          </div>

          <div class="cookie__settings-row-content" (click)="toggleAccordion($event)">
            <div class="cookie__settings-row-accordion-header">
              Zielorientierte Cookies
              <span><brt-icon [icon]="'reg-chevron-down'"></brt-icon></span>
            </div>

            <div class="cookie__settings-row-accordion-content-wrapper">
              <div class="cookie__settings-row-accordion-content">
                <span class="cookie__settings-row-accordion-content-hint">Für zielorientierte Cookies können Sie hier Ihre Einstellungen festlegen.</span>
                <div class="cookie__settings-row-accordion-content-input-wrapper">
                  <label class="checkbox">
                    <input type="checkbox" [checked]="groupedSettings[0].children[1].children[0].selected" (change)="onInputChanged(groupedSettings[0].children[1].children[0])">
                    <span class="custom-checkbox"><brt-icon [icon]="'check'"></brt-icon></span>
                    <p>
                      <strong>Google Analytics (US-amerikanischer Anbieter)</strong><br/>
                      Webseitentracking und Optimierung mit Google Analytics und Google Optimize, Signals (für geräteübergreifende Erfassung der Nutzer).
                    </p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cookie__settings-row cookie__settings-row--has-children">
          <div class="cookie__settings-row-checkbox">
            <label class="checkbox">
              <input type="checkbox" [checked]="groupedSettings[0].children[2].selected || groupedSettings[0].children[2].partiallySelected" (change)="onInputChanged(groupedSettings[0].children[2])">
              <span class="custom-checkbox"><brt-icon [icon]="groupedSettings[0].children[2].partiallySelected ? 'reg-minus' : 'check'"></brt-icon></span>
            </label>
          </div>

          <div class="cookie__settings-row-content" (click)="toggleAccordion($event)">
            <div class="cookie__settings-row-accordion-header">
              Marketing Cookies
              <span><brt-icon [icon]="'reg-chevron-down'"></brt-icon></span>
            </div>

            <div class="cookie__settings-row-accordion-content-wrapper">
              <div class="cookie__settings-row-accordion-content">
                <span class="cookie__settings-row-accordion-content-hint">Für Marketing Cookies können Sie hier Ihre Einstellungen festlegen.</span>
                <div class="cookie__settings-row-accordion-content-input-wrapper">
                  <label class="checkbox">
                    <input type="checkbox" [checked]="groupedSettings[0].children[2].children[0].selected" (change)="onInputChanged(groupedSettings[0].children[2].children[0])">
                    <span class="custom-checkbox"><brt-icon [icon]="'check'"></brt-icon></span>
                    <p>
                      <strong>Facebook (US-amerikanischer Anbieter)</strong><br/>
                      Ermöglicht die Auslieferung zielgerichteter Werbung auf Facebook.
                    </p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cookie__content-footer">
        <div class="cookie__footer-settings" (click)="openSettings()" *ngIf="!settingsOpened">Einstellungen</div>

        <div class="cookie__footer-confirm" *ngIf="!settingsOpened" (click)="accept(true)">
          <brt-button [title]="'Ich stimme zu'" color="river" size="large"></brt-button>
        </div>

        <div class="cookie__footer-settings-confirm" *ngIf="settingsOpened" (click)="accept()">
          <brt-button [title]="'Einstellungen speichern'" color="river" size="large"></brt-button>
        </div>
      </div>
    </div>
  </div>

</div>
